export var CoolblueApp;
(function (CoolblueApp) {
    CoolblueApp["ANDROID"] = "android";
    CoolblueApp["IOS"] = "ios";
})(CoolblueApp || (CoolblueApp = {}));
export var Device;
(function (Device) {
    Device["MOBILE"] = "mobile";
    Device["TABLET"] = "tablet";
    Device["DESKTOP"] = "desktop";
    Device["SMART_TV"] = "smart_tv";
    Device["UNKNOWN"] = "unknown";
})(Device || (Device = {}));
export var RequestContextHeader;
(function (RequestContextHeader) {
    RequestContextHeader["ATTEMPT_ID"] = "x-coolblue-attempt-id";
    RequestContextHeader["CLIENT_IP"] = "x-coolblue-client-ip";
    RequestContextHeader["CLOUDFRONT_REQUEST_ID"] = "x-cloudfront-request-id";
    RequestContextHeader["COOKIE_PREFERENCES"] = "x-coolblue-cookie-preferences";
    RequestContextHeader["COOLBLUE_APP"] = "x-coolblue-app";
    RequestContextHeader["COOLBLUE_CUSTOMER_ID"] = "x-coolblue-customer-id";
    RequestContextHeader["COOLBLUE_ACCOUNT_ID"] = "x-coolblue-account-id";
    RequestContextHeader["COOLBLUE_ACCOUNT_NAME"] = "x-coolblue-account-name";
    RequestContextHeader["COOLBLUE_AUTH_TOKEN"] = "x-coolblue-auth-token";
    RequestContextHeader["COOLBLUE_EMPLOYEE"] = "x-coolblue-employee";
    RequestContextHeader["COOLBLUE_SESSION_ID"] = "x-coolblue-session-id";
    RequestContextHeader["COOLBLUE_TRACKING_ID"] = "x-coolblue-tracking-id";
    RequestContextHeader["CORRELATION_ID"] = "x-coolblue-correlation-id";
    RequestContextHeader["CSRF_TOKEN"] = "x-coolblue-csrf-token";
    RequestContextHeader["CUSTOMER_PROFILE"] = "x-coolblue-customer-profile";
    RequestContextHeader["DEVICE"] = "x-coolblue-device";
    RequestContextHeader["ENVIRONMENT"] = "x-coolblue-environment";
    RequestContextHeader["IS_COOLBLUE_KNOWN_BOT"] = "x-coolblue-is-coolblue-known-bot";
    RequestContextHeader["IS_COOLBLUE_USER"] = "x-coolblue-is-coolblue-user";
    RequestContextHeader["IS_NEW_SESSION"] = "x-coolblue-is-new-session";
    RequestContextHeader["LANGUAGE"] = "x-coolblue-language";
    RequestContextHeader["ROUTE"] = "x-coolblue-route";
    RequestContextHeader["SPLIT_TESTS"] = "x-coolblue-split-tests";
    RequestContextHeader["SUBSIDIARY"] = "x-coolblue-subsidiary";
    RequestContextHeader["TRAFFIC_SOURCE"] = "x-coolblue-traffic-source";
})(RequestContextHeader || (RequestContextHeader = {}));
// https://coolblue.atlassian.net/wiki/spaces/CRCD/pages/51318308
export var CustomerType;
(function (CustomerType) {
    CustomerType["CONSUMER"] = "1";
    CustomerType["BUSINESS_CONSUMER"] = "2";
    CustomerType["B2B_CUSTOMER"] = "3";
    CustomerType["B2B_OUTLET"] = "4";
    CustomerType["B2B_FOREIGN"] = "5";
    // N/A = 6
    CustomerType["ANONYMOUS_CUSTOMER"] = "7";
    CustomerType["INTERNAL_CUSTOMER"] = "8";
})(CustomerType || (CustomerType = {}));
export var TrafficSource;
(function (TrafficSource) {
    TrafficSource["SEARCH"] = "search";
    TrafficSource["SHOPPING"] = "shopping";
    TrafficSource["PRICE_COMPARISON"] = "price-comparison";
    TrafficSource["OTHER"] = "other";
})(TrafficSource || (TrafficSource = {}));
export var TrafficMedium;
(function (TrafficMedium) {
    TrafficMedium["AFFILIATE"] = "affiliate";
    TrafficMedium["PRICE_COMPARISON"] = "pricecomparison";
})(TrafficMedium || (TrafficMedium = {}));
export var TrafficContent;
(function (TrafficContent) {
    TrafficContent["SHOPPING"] = "shopping";
})(TrafficContent || (TrafficContent = {}));
export var TrafficSourceParameter;
(function (TrafficSourceParameter) {
    TrafficSourceParameter["SOURCE"] = "utm_source";
    TrafficSourceParameter["MEDIUM"] = "utm_medium";
    TrafficSourceParameter["CONTENT"] = "utm_content";
    TrafficSourceParameter["CLICK_ID"] = "gclid";
})(TrafficSourceParameter || (TrafficSourceParameter = {}));
//# sourceMappingURL=types.js.map